<template>
    <div class="i-table-edit">
        <label>{{label}}</label>
        <table border="1">
            <tr v-for="(row,rI) in rows">
                <td v-for="(col,cI) in cols">
                    <inputi :value="data[rI] && data[rI][cI] || ''" @input="(v)=>onChange(rI,cI, v)" />
                </td>
            </tr>
        </table>
        <btn l='Добавить строку' @press="addRow()" />
        <btn l='Добавить колонку' @press="addCol()" />
    </div>
</template>
<script>
export default {

    name: 'i-table-edit',
    props: ["label", "value"],
    methods: {
        addRow() {
            this.rows.push({});
            console.log(this.$data);
        },
        addCol() {
            this.cols.push({});
            console.log(this.$data);
        },
        onChange(rI, cI, v) {
        	console.log(rI,cI,v)
            if (!this.data) this.data = [];
            if (!this.data[rI]) this.data[rI] = [];
            this.data[rI][cI] = v;
            this.$emit('input', this.data);
        }
    },
    mounted() {
        this.data = this.value || [];
        let maxCol = 0;
        this.rows = this.data.map((dI) => {
            if (dI.length > maxCol) maxCol = dI.length;
            return {};
        });
        for (let i = 0; i < maxCol; i++) {
            this.cols.push({});
        }
    },
    data() {
        return {
            rows: [],
            cols: [],
            data: []
        }
    }
}
</script>
<style lang="css" scoped>
</style>